import React from "react";
import { Box, Typography, Button, Container } from "@mui/material";
import { useLanguage } from "../../context/LanguageContext";

const WhoCorp = () => {
  const { language, translations } = useLanguage();
  return (
    <Box
      sx={{
        position: "relative",
        width: "100%",
        minHeight: "100vh",
        backgroundImage: "url('https://res.cloudinary.com/dk24unkwu/image/upload/v1753695261/updateBanner_cgtox8.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        color: "#fff",
        textAlign: "center",
        px: 2, // ✅ horizontal padding for small devices
      }}
    >
      {/* Overlay */}
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
        }}
      />

      {/* Content */}
      <Container
        maxWidth="md"
        sx={{
          position: "relative",
          zIndex: 1,
          py: { xs: 6, sm: 10 }, // ✅ top/bottom spacing for small devices
        }}
      >
        <Typography variant="h2">
          {translations[language]?.whoCorpTitle || "Fair. Transparent. Empowering."}
        </Typography>

        <Typography
          sx={{
            mt: 2,
            fontSize: { xs: "1rem", sm: "1.125rem", md: "1.25rem" },
            color: "rgba(255, 255, 255, 0.85)",
            maxWidth: 500,
            mx: "auto",
            fontWeight: 400,
            lineHeight: 1.6,
          }}
        >
          {translations[language]?.whoCorpSubtitle || "We believe access to global markets is a right — not a privilege."}
        </Typography>

        <Button
          component="a"
          href="https://portal.bbcorp.trade/auth/jwt/sign-up/"
          target="_blank"
          rel="noopener noreferrer"
          disableRipple
          sx={{
            mt: { xs: 3, sm: 5 },
            background: "#fff",
            color: "#000",
            fontWeight: 600,
            padding: "12px 30px",
            borderRadius: "10px",
            textTransform: "capitalize",
            fontSize: { xs: "14px", sm: "16px" },
            "&:hover": {
              background: "#000",
              color: "#fff",
            },
          }}
        >
          {translations[language]?.whoCorpButton || "Open Trading Account"}
        </Button>
      </Container>
    </Box>
  );
};

export default WhoCorp;
